const validarCPF = (cpf) => {
  var Soma = 0
  var Resto

  cpf = cpf.replace(/[^\d]+/g, ''); // Remove tudo que não for dígito

  if (cpf.length !== 11 ||
		cpf === "00000000000" ||
		cpf === "11111111111" ||
		cpf === "22222222222" ||
		cpf === "33333333333" ||
		cpf === "44444444444" ||
		cpf === "55555555555" ||
		cpf === "66666666666" ||
		cpf === "77777777777" ||
		cpf === "88888888888" ||
		cpf === "99999999999") return false; // CPF deve ter 11 dígitos

  for (let i=1; i<=9; i++) {
    Soma = Soma + parseInt(cpf.substring(i-1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;
  }

  if ((Resto == 10) || (Resto == 11))  Resto = 0;
  if (Resto != parseInt(cpf.substring(9, 10)) ) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++) {
    Soma = Soma + parseInt(cpf.substring(i-1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;
  }

  if ((Resto == 10) || (Resto == 11))  Resto = 0;
  if (Resto != parseInt(cpf.substring(10, 11) ) ) return false;

  return true;
}

const validarCNPJAlfaNumerico = (cnpj) => {

  try {
    const TAMANHO_CNPJ = 14;
    const TAMANHO_CNPJ_SEM_DV = 12;
    const REGEX_CNPJ_SEM_DV = /^([A-Z\d]){12}$/;
    const REGEX_CNPJ = /^([A-Z\d]){12}(\d){2}$/;
    const REGEX_CARACTERES_MASCARA = /[./-]/g;
    const REGEX_CARACTERES_NAO_PERMITIDOS = /[^A-Z\d./-]/i;
    const VALOR_BASE = '0'.charCodeAt(0);
    const PESOS_DV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const CNPJ_ZERADO = '00000000000000';

    const removeMascaraCNPJ = (cnpj) => {
      return cnpj.replace(REGEX_CARACTERES_MASCARA, '');
    };

    const calculaDV = (cnpj) => {
      if (!REGEX_CARACTERES_NAO_PERMITIDOS.test(cnpj)) {
        const cnpjSemMascara = removeMascaraCNPJ(cnpj);

        if (
          REGEX_CNPJ_SEM_DV.test(cnpjSemMascara) &&
          cnpjSemMascara !== CNPJ_ZERADO.substring(0, TAMANHO_CNPJ_SEM_DV)
        ) {
          let somatorioDV1 = 0;
          let somatorioDV2 = 0;

          for (let i = 0; i < TAMANHO_CNPJ_SEM_DV; i++) {
            const asciiDigito = cnpjSemMascara.charCodeAt(i) - VALOR_BASE;
            somatorioDV1 += asciiDigito * PESOS_DV[i + 1];
            somatorioDV2 += asciiDigito * PESOS_DV[i];
          }

          const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
          somatorioDV2 += dv1 * PESOS_DV[TAMANHO_CNPJ_SEM_DV];
          const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);

          return `${dv1}${dv2}`;
        }
      }
      throw new Error('Não é possível calcular o DV pois o CNPJ fornecido é inválido');
    };

    if (!REGEX_CARACTERES_NAO_PERMITIDOS.test(cnpj)) {
      const cnpjSemMascara = removeMascaraCNPJ(cnpj).toUpperCase().padStart(TAMANHO_CNPJ, '0');

      if (REGEX_CNPJ.test(cnpjSemMascara) && cnpjSemMascara !== CNPJ_ZERADO) {
        const dvInformado = cnpjSemMascara.substring(TAMANHO_CNPJ_SEM_DV);
        const dvCalculado = calculaDV(cnpjSemMascara.substring(0, TAMANHO_CNPJ_SEM_DV));
        return dvInformado === dvCalculado;
      }
    }
  } catch (error) {
    return false;
  }
  return false;
}

export { validarCPF, validarCNPJAlfaNumerico };
